const fadeInAnimation = {
  '@keyframes fadeIn': {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 },
  },
};

const styles = theme => ({
  '@global': {
    '*': { fontFamily: 'Arial, sans-serif' },

    '@media print': {
      '*::-webkit-scrollbar': { display: 'none' },
      '.navContainer': { display: 'none !important' },
      '#backButton': { display: 'none !important' },
      '#nextButton': { display: 'none !important' },
      'html, body': {
        margin: '0 !important',
        padding: '0 !important',
        width: 'auto !important',
        background: '#FFFFFF !important',
      },
      '.MuiTableCell-root': {
        padding: '4px 8px !important',
        boxSizing: 'border-box',
      },
    },

    '@page': {
      size: 'A4 portrait',
      margin: '12mm',
    },
  },

  ...fadeInAnimation,
  fadeIn: { animation: '$fadeIn 0.6s ease-in-out forwards' },

  navButton: {
    backgroundColor: '#6553A7',
    color: '#FFFFFF',
    fontSize: '24px',
    minWidth: '120px',
    borderRadius: 0,
    textTransform: 'none',
    padding: '4px 16px',
    transition: 'background-color 0.2s ease',
    '&:hover': { backgroundColor: '#46388ACC' },
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
      minWidth: '88px',
      padding: '2px 12px',
    },
  },
  navButtonDisabled: {
    backgroundColor: '#CAC8D2',
    color: '#FFFFFF',
    fontSize: '24px',
    minWidth: '120px',
    borderRadius: 0,
    textTransform: 'none',
    padding: '4px 16px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
      minWidth: '88px',
      padding: '2px 12px',
    },
  },

  welcomeHeader: {
    color: '#7A5DC9',
    fontWeight: 700,
    fontSize: '27px',
    marginBottom: '1rem',
    overflowWrap: 'break-word',
  },

  appContainer: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    overflowWrap: 'break-word',
  },
  contentWrapper: {
    flex: 1,
    position: 'relative',
    paddingBottom: '100px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowWrap: 'break-word',
  },
  navContainer: {
    position: 'absolute',
    bottom: '40px',
    left: 0,
    right: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowWrap: 'break-word',
    zIndex: 1,
  },

  grid: {
    display: 'grid',
    backgroundColor: '#F8F8FA',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    flexGrow: 1,
    minHeight: '100vh',
    width: '100%',
    overflowX: 'auto',
    overflowY: 'auto',
    overflowWrap: 'break-word',
  },

  paper: { backgroundColor: '#F8F8FA', boxShadow: 'none', border: 'none' },

  appHeader: {
    paddingTop: 'calc(0.5% + 10px)',
    paddingBottom: 'calc(0.5% + 10px)',
    fontSize: '30px',
    position: 'relative',
    cursor: 'default',
    width: '100%',
    minHeight: 50,
    backgroundColor: '#FFFFFF',
    color: '#0F145C',
    fontFamily: 'Poppins, sans-serif',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflowWrap: 'break-word',
  },
  headerString: {
    display: 'flex',
    alignItems: 'center',
    color: 'black',
    textDecoration: 'none',
    '& span': { fontSize: '1.2em', overflowWrap: 'break-word' },
  },

  footer: {
    color: 'white',
    paddingTop: '10px',
    paddingBottom: '10px',
    textAlign: 'center',
    position: 'inherit',
    lineHeight: '120%',
    width: '100%',
    fontSize: '10pt',
    overflowWrap: 'break-word',
  },
  linkFooter: {
    textDecoration: 'none',
    cursor: 'pointer',
    color: 'white',
    '&:hover': { textDecoration: 'underline', color: '#ED6A1F' },
    '&:visited': { color: 'white' },
  },

  whiteBoxContainer: {
    width: '90%',
    maxWidth: '1320px',
    minWidth: '1320px',
    backgroundColor: '#fff',
    borderRadius: 0,
    padding: '40px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    marginBottom: '40px',
    overflowWrap: 'break-word',
    [theme.breakpoints.down('xs')]: { padding: '20px' },
  },

  stepBoxContainer: {
    width: '90%',
    maxWidth: '1320px',
    minWidth: '1320px',
    backgroundColor: '#fff',
    borderRadius: 0,
    fontSize: '24px',
    padding: '20px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    marginBottom: '40px',
    marginTop: '40px',
    overflowWrap: 'break-word',
    [theme.breakpoints.down('xs')]: { padding: '20px' },
  },

  selectionWrapper: {
    width: '90%',
    maxWidth: '1320px',
    minWidth: '1320px',
    margin: '0 0 -80px 0',
    backgroundColor: '#F8F8FA',
    marginBottom: '40px',
    overflowWrap: 'break-word',
  },

  startControlsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    width: '100%',
    maxWidth: '1320px',
    margin: '0 0 0 0',
    boxSizing: 'border-box',
    '@media print': { display: 'none !important' },
    '& > *': { marginBottom: 0, flexShrink: 0 },
  },

  dropdownWrapper: {
    display: 'inline-flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    minWidth: '600px',
    maxWidth: '600px',
    marginBottom: '40px',
    '&:nth-of-type(odd)': { marginRight: '40px' },
  },

  dropdownHeader: {
    fontSize: '20px',
    fontWeight: 'bold',
    padding: '0 0 0 5px',
    color: '#0F145C',
    marginBottom: '8px',
  },

  hideInternalLabel: {
    '& label': { display: 'none' },
  },

  resultFormControlNoMB: { marginBottom: 0 },

  whiteInputLabel: { color: '#0F145C !important', fontSize: '18px' },

  whiteUnderline: {
    '&:before': { borderBottom: '1px solid #E5E7EB !important' },
    '&:hover:not(.Mui-disabled):before': { borderBottom: '2px solid #0F145C !important' },
    '&:after': { borderBottom: '2px solid #46388A !important' },
  },

  whiteInput: { color: '#0F145C', fontSize: '18px' },
  whiteIcon: { color: '#0F145C' },

  edgeDiv: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E7EB',
    padding: '16px 24px 8px',
    borderRadius: 0,
    display: 'inline-flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    minWidth: 'calc(50% - 20px)',
    maxWidth: 'calc(50% - 20px)',
    marginBottom: '40px',
    '&:nth-of-type(odd)': { marginRight: '40px' },
    '@media print': { display: 'none !important' },
  },

  edgeWhiteLabel: { color: '#0F145C', fontSize: '18px', marginBottom: '8px' },

  edgeWhiteInput: {
    backgroundColor: '#FFFFFF',
    color: '#0F145C',
    fontSize: '18px',
    padding: '10px 12px',
    border: '1px solid #E5E7EB',
    borderRadius: 0,
    outline: 'none',
    width: '100%',
    '&:focus': { borderColor: '#0F145C' },
  },

  edgeWhiteIcon: { color: '#0F145C', padding: '4px' },
  resultMenuItem: { color: '#0F145C', fontSize: '18px' },

  moreInformations: {
    color: '#718FB7',
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': { color: '#5E4B9A' },
  },

  mobileWhiteBoxContainer: { [theme.breakpoints.down('sm')]: { width: 'auto', maxWidth: '100%', minWidth: 'auto', padding: '20px', margin: '20px' } },
  mobileStepBoxContainer: { [theme.breakpoints.down('sm')]: { width: 'auto', maxWidth: '100%', minWidth: 'auto', padding: '16px', margin: '20px', fontSize: '20px' } },
  mobileSelectionWrapper: { [theme.breakpoints.down('sm')]: { width: '100%', maxWidth: '100%', minWidth: 'auto', margin: '0' } },
  mobileStartControlsRow: { [theme.breakpoints.down('sm')]: { flexDirection: 'column', alignItems: 'stretch', padding: '0 16px', gap: '16px 0' } },
  mobileDropdownWrapper: { [theme.breakpoints.down('sm')]: { minWidth: '100%', maxWidth: '100%', margin: '0 0 20px 0' } },
  mobileStartFormControl: { [theme.breakpoints.down('sm')]: { minWidth: '100%', maxWidth: '100%' } },
  mobileEdgeDiv: { [theme.breakpoints.down('sm')]: { minWidth: '100%', maxWidth: '100%', marginRight: 0 } },

  tabletWhiteBoxContainer: { [theme.breakpoints.between('sm', 'md')]: { width: 'auto', maxWidth: '100%', minWidth: 'auto', padding: '28px', margin: '20px' } },
  tabletStepBoxContainer: { [theme.breakpoints.between('sm', 'md')]: { width: 'auto', maxWidth: '100%', minWidth: 'auto', padding: '18px', margin: '20px', fontSize: '22px' } },
  tabletSelectionWrapper: { [theme.breakpoints.between('sm', 'md')]: { width: '100%', maxWidth: '100%', minWidth: 'auto', margin: '0' } },
  tabletStartControlsRow: { [theme.breakpoints.between('sm', 'md')]: { flexDirection: 'column', alignItems: 'stretch', padding: '0 24px', gap: '0' } },
  tabletDropdownWrapper: { [theme.breakpoints.between('sm', 'md')]: { minWidth: '100%', maxWidth: '100%', margin: '0 0 20px 0' } },
  tabletStartFormControl: { [theme.breakpoints.between('sm', 'md')]: { minWidth: '100%', maxWidth: '100%' } },
  tabletEdgeDiv: { [theme.breakpoints.between('sm', 'md')]: { minWidth: '100%', maxWidth: '100%', marginRight: 0 } },

  titleUnderline: { border: 0, borderBottom: '1px solid #0F145C', width: '45%', margin: '10px 0 20px' },

  formControlCommon: {
    '& .MuiOutlinedInput-root': { backgroundColor: '#fff', border: '1px solid #CDD0D4', borderRadius: 0 },
    '& .MuiSelect-select': { padding: '12px', color: '#0F145C', fontSize: '18px' },
  },
  menuItemCommon: { whiteSpace: 'normal' },

  sectionHeader: {
    backgroundColor: '#FFFFFF',
    maxWidth: '1320px',
    minWidth: '1320px',
    height: '70px',
    padding: '0 40px',
    margin: '40px auto 0',
    display: 'flex',
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    alignItems: 'center',
  },
  sectionHeaderStep4: {
    backgroundColor: '#FFFFFF',
    maxWidth: '1320px',
    minWidth: '1320px',
    height: '70px',
    margin: '40px auto 40px',
    display: 'flex',
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    alignItems: 'center',
    '@media print': { display: 'none !important' },
  },

  stepNumber: { fontSize: '24px', fontWeight: 600, padding: '0 0 0 40px', color: '#0F145C' },
  stepText: { fontSize: '22px', fontWeight: 400, color: '#0F145C', marginLeft: '8px' },

  cardsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: '24px 16px',
    padding: '40px 0 0 0',
    maxWidth: '1320px',
    margin: '0 0 0 60px',
  },

  deviceCard: {
    flex: '0 1 calc(25% - 16px)',
    maxWidth: '280px',
    minWidth: '200px',
    height: '70px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E7EB',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px',
    cursor: 'pointer',
    '&:hover': { borderColor: '#ED6A1FCC', boxShadow: '0 0 0 4px rgba(237, 106, 31, 0.10)' },
  },
  cardSymbol: { fontSize: '22px', fontWeight: 600, color: '#0F145C' },
  cardLabel: { fontSize: '14px', fontWeight: 400, color: '#6B7280', marginTop: '6px', textAlign: 'center' },

  listContainer: {
    backgroundColor: '#FFFFFF',
    boxShadow: '0 2px 6px #E5E5EB',
    padding: '40px 20px 40px 20px',
    maxWidth: '1280px',
    minWidth: '1280px',
    maxHeight: '240px',
    overflowY: 'auto',
    margin: '40px 0px 80px 15px',
    alignItems: 'center',
    width: '100%',
  },
  listRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid rgb(113, 143, 183)',
    height: '50px',
    marginTop: '0px',
    marginBottom: '0px',
    padding: 0,
  },
  listLeft: { display: 'flex', alignItems: 'center' },
  listIndex: { fontSize: '18px', fontWeight: 600, color: '#F97316', marginRight: '8px' },
  listName: { fontSize: '19px', fontWeight: 600, color: '#0F145C' },
  listSeparator: { fontSize: '18px', fontWeight: 400, color: '#0F145C', margin: '0 8px' },
  listSub: { fontSize: '18px', fontWeight: 400, color: '#0F145C' },
  listActions: {
    padding: '8px',
    cursor: 'pointer',
    '& svg': { color: '#9CA3AF' },
    '&:hover svg': { color: '#6B7280' },
  },
  menuIcon: { display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '4px' },
  dot: { width: '4px', height: '4px', backgroundColor: '#9CA3AF' },
  emptyText: { fontSize: '18px', color: '#9CA3AF', textAlign: 'center', width: '100%' },

  dialogPaper: {
    padding: '32px 40px 24px',
    borderRadius: 0,
    maxWidth: 500,
    width: 'calc(100% - 48px)',
    border: '1px solid #E5E7EB',
    boxShadow: '0 5px 15px #718FB7CC',
  },
  dialogTitle: {
    paddingBottom: 0,
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: -20,
      left: 20,
      width: '85%',
      height: 2,
      backgroundColor: '#718FB7',
    },
  },
  dialogContent: { paddingTop: '40px', paddingBottom: '100px' },
  dialogActions: { paddingBottom: '24px', justifyContent: 'flex-end' },

  blueFieldRoot: {
    border: '2px solid #718FB7CC',
    padding: '7px',
    borderRadius: 0,
    textAlign: 'center',
    '&:hover': { border: '2px solid #ED6A1FCC' },
    '& .MuiOutlinedInput-root': {
      borderRadius: 0,
      '& fieldset': { borderColor: '#0F145C', borderWidth: 2, borderRadius: 0 },
      '&:hover fieldset': { borderColor: '#F97316' },
      '&.Mui-focused fieldset': { borderColor: '#F97316' },
    },
  },
  orangeFieldRoot: {
    border: '2px solid #718FB7CC',
    padding: '7px',
    borderRadius: 0,
    textAlign: 'center',
    '&:hover': { border: '2px solid #ED6A1FCC' },
    '& .MuiOutlinedInput-root': {
      borderRadius: 0,
      '& fieldset': { borderColor: '#F97316', borderWidth: 2, borderRadius: 0 },
      '&:hover fieldset': { borderColor: '#F97316' },
      '&.Mui-focused fieldset': { borderColor: '#F97316' },
    },
  },

  numberInputBlue: { color: '#0F145C', fontSize: '18px' },
  numberInputOrange: { color: '#0F145C', fontSize: '18px' },

  cancelButton: {
    backgroundColor: '#ED6A1FCC',
    color: '#FFFFFF',
    fontWeight: 600,
    textTransform: 'none',
    minWidth: 130,
    padding: '10px',
    '&:hover': { backgroundColor: '#ED6A1F' },
  },
  addButton: {
    backgroundColor: '#46388ACC',
    color: '#FFFFFF',
    fontWeight: 600,
    textTransform: 'none',
    minWidth: 130,
    padding: '10px',
    '&:hover': { backgroundColor: '#46388A' },
  },

  resultContainer: {
    backgroundColor: '#F8F8FA',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',
    width: '100%',
    maxWidth: '1320px',
    minWidth: '1320px',
    overflowWrap: 'break-word',
    '@media print': {
      width: '100% !important',
      maxWidth: '100% !important',
      minWidth: 'auto !important',
      padding: '0 !important',
      margin: '0 auto !important',
    },
  },

  controlsRow: {
    width: '100%',
    maxWidth: '1320px',
    minWidth: '1320px',
    alignItems: 'baseline',
    borderBottom: '2px solid #718FB7',
    marginBottom: '80px',
    '@media print': { display: 'none !important' },
  },

  resultFormControl: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E7EB',
    padding: '8px 16px 8px',
    borderRadius: 0,
    display: 'inline-flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    minWidth: '600px',
    maxWidth: '600px',
    maxHeight: '66px',
    marginBottom: '40px',
    '&:nth-of-type(odd)': { marginRight: '0px' },
    '& label': { color: '#0F145C', fontSize: '18px', marginBottom: '8px' },
    '@media print': { display: 'none !important' },
  },

  startFormControl: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E7EB',
    padding: '8px 16px 8px',
    borderRadius: 0,
    display: 'inline-flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    minWidth: '600px',
    maxWidth: '600px',
    maxHeight: '66px',
    marginBottom: '40px',
    '&:nth-of-type(odd)': { marginRight: '0px' },
    '& label': { color: '#0F145C', fontSize: '18px', marginBottom: '8px' },
    '@media print': { display: 'none !important' },
  },

  resultExpansionPanel: {
    width: '100%',
    maxWidth: '1320px',
    minWidth: '1320px',
    border: '1px solid #E5E7EB',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    marginBottom: '40px',
    overflowWrap: 'break-word',
    '@media print': {
      width: '100% !important',
      maxWidth: '100% !important',
      minWidth: 'auto !important',
      margin: '0 0 20px !important',
      border: 'none !important',
      boxShadow: 'none !important',
    },
  },

  expansionPanelSummary: { color: '#0F145C' },

  expansionDetails: {
    flexDirection: 'column',
    padding: '5px 15px 32px 0',
    '@media print': {
      padding: '4px 4px 12px 4px',
    },
  },

  heading: { fontSize: '20px', fontWeight: 600, color: '#0F145C', width: '100%', textAlign: 'left' },
  rowName: { fontSize: '18px', fontWeight: 300, color: '#0F145C', textAlign: 'left' },

  scrollableTable: {
    width: '100%',
    maxWidth: '1320px',
    minWidth: '1320px',
    overflowX: 'auto',
    marginBottom: '40px',
    '& table': { width: '100%', borderCollapse: 'collapse' },
    '& table thead th': {
      backgroundColor: '#F3F4F6',
      color: '#0F145C',
      fontSize: '18px',
      fontWeight: 600,
      textAlign: 'left',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
    },
    '& table tbody td': {
      fontSize: '18px',
      color: '#0F145C',
      textAlign: 'left',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
    },
    '@media print': {
      overflow: 'visible !important',
      maxHeight: 'none !important',
      minWidth: 'auto !important',
      maxWidth: '100% !important',
      width: '100% !important',
      marginBottom: '16px !important',
      paddingRight: '6mm',
      boxSizing: 'border-box',
      '& table': { tableLayout: 'fixed !important', width: '100% !important' },
      '& table thead th, & table tbody td': { fontSize: '14px !important', padding: '4px 8px !important', boxSizing: 'border-box' },
    },
  },

  tableOverview: {
    width: '100%',
    borderCollapse: 'collapse',
    '& thead th': {
      backgroundColor: '#F3F4F6',
      color: '#0F145C',
      fontSize: '18px',
      fontWeight: 600,
      textAlign: 'left',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
    },
    '& tbody td': {
      fontSize: '18px',
      color: '#0F145C',
      textAlign: 'left',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
    },
    '@media print': {
      '& thead': { display: 'table-header-group' },
      '& tr': { pageBreakInside: 'avoid !important', pageBreakAfter: 'auto !important' },
      tableLayout: 'fixed !important',
      width: '100% !important',
      '& thead th, & tbody td': { fontSize: '14px !important', padding: '4px 8px !important', boxSizing: 'border-box' },
      '& thead th:last-child, & tbody td:last-child': {
        paddingRight: '6mm !important',
      },
    },
  },

  longTermTable: {
    width: '100%',
    borderCollapse: 'collapse',
    '& thead th': {
      backgroundColor: '#F3F4F6',
      color: '#0F145C',
      fontSize: '18px',
      fontWeight: 600,
      textAlign: 'left',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
    },
    '& tbody td': {
      fontSize: '18px',
      color: '#0F145C',
      textAlign: 'left',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
    },
    '@media print': {
      '& thead': { display: 'table-header-group' },
      '& tr': { pageBreakInside: 'avoid !important', pageBreakAfter: 'auto !important' },
      tableLayout: 'fixed !important',
      width: '100% !important',
      '& th, & td': { width: '33.33%' },
      '& thead th, & tbody td': { fontSize: '14px !important', padding: '4px 8px !important', boxSizing: 'border-box' },
    },
  },

  recommendationTable: {
    width: '100%',
    borderCollapse: 'collapse',
    '& thead th': {
      backgroundColor: '#F3F4F6',
      color: '#0F145C',
      fontSize: '18px',
      fontWeight: 600,
      textAlign: 'left',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
    },
    '& tbody td': {
      fontSize: '18px',
      color: '#0F145C',
      textAlign: 'left',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
    },
    '@media print': {
      '& thead': { display: 'table-header-group' },
      '& tr': { pageBreakInside: 'avoid !important', pageBreakAfter: 'auto !important' },
      tableLayout: 'fixed !important',
      width: '100% !important',
      '& thead th, & tbody td': { fontSize: '14px !important', padding: '4px 8px !important', boxSizing: 'border-box' },
    },
  },

  row: { '&:nth-of-type(even)': { background: '#FAFAFB' } },

  devicesSummaryContainer: {
    width: '100%',
    maxWidth: '1320px',
    minWidth: '1320px',
    margin: '40px auto 0',
    '@media print': {
      minWidth: 'auto !important',
      maxWidth: '100% !important',
      width: '100% !important',
      margin: '20px 0 0 0 !important',
    },
  },

  total: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#0F145C',
    marginTop: '24px',
    textAlign: 'right',
    '@media print': {
      textAlign: 'center',
      width: '100%',
      display: 'block',
      fontSize: '16px',
    },
  },

  printButton: {
    backgroundColor: '#ED6A1FCC',
    color: '#FFFFFF',
    fontSize: '20px',
    fontWeight: 600,
    minWidth: '120px',
    minHeight: '50px',
    borderRadius: 0,
    marginTop: '12px',
    textTransform: 'none',
    padding: '4px 16px',
    position: 'relative',
    zIndex: 2,
    pointerEvents: 'auto',
    '&:hover': { backgroundColor: '#ED6A1F' },
    '@media print': { display: 'none !important' },
  },

  printModalBackdrop: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 1300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  printModal: {
    backgroundColor: '#FFFFFF',
    padding: '30px',
    borderRadius: 0,
    width: '90%',
    maxWidth: '500px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  printModalTitle: { color: '#0F145C', fontSize: '24px', fontWeight: 600, marginBottom: '16px' },
  printModalLabel: { color: '#0F145C', fontSize: '24px', display: 'flex', alignItems: 'center', gap: '12px' },
  printModalButtons: { display: 'flex', justifyContent: 'flex-end', gap: '24px', marginTop: '16px' },
  printModalCancelButton:{
    backgroundColor: '#ED6A1FCC',
    color: '#FFFFFF',
    fontWeight: 600,
    textTransform: 'none',
    minWidth: 130,
    padding: '10px',
    '&:hover': { backgroundColor: '#ED6A1F' },
  },
  printModalPrintButton: {
    backgroundColor: '#46388ACC',
    color: '#FFFFFF',
    fontWeight: 600,
    textTransform: 'none',
    minWidth: 130,
    padding: '10px',
    '&:hover': { backgroundColor: '#46388A' },
  },

  snackbarContent: {
    backgroundColor: '#46388ACC',
    textAlign: 'center',
    color: '#FFFFFF',
    fontSize: '20px',
    fontWeight: 500,
  },

  printExclude: { display: 'none' },

  resultControlsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: '1320px',
    margin: '0 0 40px 0',
    padding: '0 0 0 0',
    boxSizing: 'border-box',
    '@media print': { display: 'none !important' },
    '& > *': { marginBottom: 0, flexShrink: 0 },
  },

  resultBoxesRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '40px',
    width: '100%',
    maxWidth: '1320px',
    margin: '0 auto 40px',
    boxSizing: 'border-box',
  },
  resultBox: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E7EB',
    borderRadius: 0,
    flex: '1 1 calc(50% - 40px)',
    minWidth: '400px',
    padding: '16px 24px',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
  },
  resultBoxTitle: { fontSize: '18px', fontWeight: 600, color: '#0F145C', marginBottom: '8px', lineHeight: 1.25 },
  resultBoxFormControl: {
    '& .MuiInputBase-input': { fontSize: '18px', color: '#0F145C' },
    '& .MuiInputLabel-root': { fontSize: '18px', color: '#0F145C' },
    '& .MuiInput-underline:before': { borderBottomColor: '#E5E7EB' },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#0F145C' },
    '& .MuiInput-underline:after': { borderBottomColor: '#0F145C', borderBottomWidth: 2 },
  },
  resultBoxIconButton: { padding: 4, color: '#0F145C', '&:hover': { color: '#46388A' } },

  tableWrapper1320: {
    width: '100%',
    maxWidth: '1320px',
    minWidth: '1320px',
    overflowX: 'auto',
    margin: '0 auto 40px',
    '@media print': {
      overflowX: 'visible !important',
      minWidth: 'auto !important',
      maxWidth: '100% !important',
    },
  },

  tableHeadLight: {
    '& th': { backgroundColor: '#F3F4F6', color: '#0F145C', fontSize: '18px', fontWeight: 600, textAlign: 'center' },
  },
  tableZebraBody: {
    '& tr:nth-of-type(even) td': { backgroundColor: '#FAFAFB' },
    '& td': { fontSize: '18px', color: '#0F145C', textAlign: 'center' },
  },
  equalColumns4: { tableLayout: 'fixed', '& th, & td': { width: '25%' } },
  equalColumns3: { tableLayout: 'fixed', '& th, & td': { width: '33.33%' } },
});

export default styles;



// WEBPACK FOOTER //
// ./src/styles.js